




export default {
  name: 'IconHash',
};
